import clsx from "clsx";
import React from "react";
import { Author } from "./Author";
import { Content } from "./Content";
import { Date } from "./Date";
import { EditorialComment } from "./EditorialComment";
import { FullStory } from "./FullStory";
import { Thumbnail } from "./Thumbnail";
import { newsDisplayIsSummaryType, newsItemType } from "../../../common/types/search/news";

interface NewsItemProps {
	item: newsItemType;
	summary: newsDisplayIsSummaryType;
}

export function NewsItem({ item, summary }: NewsItemProps) {
	const published = item.get("published");
	const title = item.get("title");
	const url = item.get("uri");

	return (
		<article className={clsx("post", { full: !summary })}>
			<Thumbnail
				summary={summary}
				picture={item.get("picture")}
				item={item}
				title={title}
				url={url}
			/>

			<div className="post__content">
				<h2 className="post__title">
					<a href={url}>{title}</a>
				</h2>
				{!summary && (
					<Author author={item.get("author")} date={published} />
				)}
				<Content item={item} summary={summary} />
				<EditorialComment
					editorialComment={item.get("editorial_comment")}
					summary={summary}
				/>
				<FullStory sources={item.get("sources")} />
				{summary && <Date date={published} />}
			</div>
		</article>
	);
}
